import { useCallback, useEffect, useState } from 'react';

const usePWAInstall = () => {
    // State to hold the BeforeInstallPromptEvent object
    const [deferredPrompt, setDeferredPrompt] = useState(null);

    // State to control the visibility of UI
    const [installAvailable, setInstallAvailable] = useState(false);

    // Event handler for the beforeinstallprompt event
    useEffect(() => {
        const handler = (e) => {
            //Defer the event
            e.preventDefault();

            // Stash the event and make the UI visible
            setDeferredPrompt(e);
            setInstallAvailable(true);
        };

        const appInstalledHandler = () => {
            // Clean up after successful install
            setDeferredPrompt(null);
            setInstallAvailable(false);
        };

        window.addEventListener('beforeinstallprompt', handler);
        window.addEventListener('appinstalled', appInstalledHandler);

        // remove event listeners when the component unmounts
        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
            window.removeEventListener('appinstalled', appInstalledHandler);
        };
    }, []);

    // Function to trigger the native prompt
    const promptInstall = useCallback(async () => {
        if (!deferredPrompt) {
            return false;
        }

        //Call the native prompt() method
        deferredPrompt.prompt();

        const { outcome } = await deferredPrompt.userChoice;

        //Hide the custom UI regardless of the outcome, as prompt() can only be called once
        setInstallAvailable(false);
        setDeferredPrompt(null);

        return outcome === 'accepted';
    }, [deferredPrompt]);

    // Return the state and the function to be used by component
    return { installAvailable, promptInstall };
};

export default usePWAInstall;